var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('core-app-bar'),_c('core-drawer'),_c('core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }